import { render, staticRenderFns } from "./A168.vue?vue&type=template&id=98b92444&scoped=true&"
import script from "./A168.vue?vue&type=script&lang=js&"
export * from "./A168.vue?vue&type=script&lang=js&"
import style0 from "./A168.vue?vue&type=style&index=0&id=98b92444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b92444",
  null
  
)

export default component.exports